module.exports = __webpack_public_path__ + "img/deluxe-vehicle-filter-cjdr.79d84fbb.png";